<script setup>
import { AbcHeading, AbcIcon } from "@ordbogen-npm/abc-dsk";
import { useI18n } from "vue-i18n";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import { Color, Size } from "@/abc-dsk/options";
import VocabService from "@/common/api/vocab.service";
import NotificationService from "@/common/notification.service";
import router from "@/router";

const props = defineProps({
  shareCode: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["cancel"]);

const { t } = useI18n();

const onCancel = () => {
  emit("cancel");
};

const onRemove = async () => {
  try {
    await VocabService.deleteList(props.shareCode);

    NotificationService.success(
      t("vocab.vocabList.wordListDelete.successToast", { name: props.name })
    );
    router.push({ name: "vocab.home" });
  } catch (e) {
    NotificationService.error(t("vocab.vocabList.wordListDelete.errorToast"));
  }
};
</script>

<template>
  <TgModal alert :size="Size.Md" :color="Color.Red" @close="onCancel()">
    <AbcHeading tag="h1" size="md" color="black" class="d-flex align-items-center">
      <AbcIcon name="exclamation" class="mr-2" color="red" />
      <span>{{ t("vocab.vocabList.wordListDelete.modalHeading") }}</span>
    </AbcHeading>
    <div class="row mt-3 mb-5">
      <div class="col-12">
        <p class="list-delete-explanation">
          {{ t("vocab.vocabList.wordListDelete.modalExplanationText", { name }) }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-center justify-content-sm-end">
        <TgButton color="grey" variant="text" class="mr-3" @click="onCancel()">
          {{ t("vocab.vocabList.wordListDelete.cancelDelete") }}
        </TgButton>
        <TgButton size="md" color="red" @click="onRemove()">
          <span class="button-icon-wrapper">
            <span>{{ t("vocab.vocabList.wordListDelete.buttonText") }}</span>
            <AbcIcon name="trash" color="white" />
          </span>
        </TgButton>
      </div>
    </div>
  </TgModal>
</template>

<style lang="less" scoped>
.button-icon-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.list-delete-explanation {
  margin-bottom: 0;
  white-space: pre-line;
}
</style>
